export const Hero = ({ className }: { className?: string }) => (
    <section {...{ className }}>
        <div className="relative mx-auto text-center max-w-4xl">
            <div
                className="absolute inset-0 -z-10 opacity-40 pointer-events-none"
                style={{
                    backgroundImage:
                        "radial-gradient(circle at 50% 0%, var(--primary) 0%, transparent 55%)",
                    filter: "blur(60px)",
                }}
            />
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-semibold mb-6 border border-primary/20">
                Developer Access
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight tracking-tight">
                CBN Regulatory <span className="text-primary">Sandbox</span>
            </h1>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
                Everything developers need to build, test, and go live on the Central Bank of Nigeria
                Regulatory Sandbox.
            </p>
        </div>
    </section>
)